import { createContext } from 'react';

const NotificationsContext = createContext(null);
NotificationsContext.displayName = "@mantine/notifications/NotificationsContext";

export { NotificationsContext };
//# sourceMappingURL=Notifications.context.js.map
